import { BillOfMaterialsLineItemType, PlasticsHardwareItem, PlasticsMaterial, Product, ProductVersion, ScheduledProductCompleteData, MoldingTaskDependantData } from "@prism/prism-shared";


export function toScheduledProductCompleteData(curr: MoldingTaskDependantData): ScheduledProductCompleteData {
    return {
        scheduledProduct: curr.moldingTask,
        product: curr.product,
        productVersion: curr.productVersion,
        hardwareItemLineItems: curr.lineItems
            .filter(li => li.type === BillOfMaterialsLineItemType.Hardware)
            .map(lineItem => {
                const vendorHardwareData = curr.vendorHardwareData.filter(vhd => vhd.parentHardwareItemId === lineItem.entityId)
                return {
                    lineItem,
                    hardwareItem: curr.lineItemHardwareItems.find(hardwareItem => hardwareItem.id === lineItem.entityId) as PlasticsHardwareItem,
                    vendorHardwareData,
                }
            }),
        productLineItems: curr.lineItems
            .filter(li => li.type === BillOfMaterialsLineItemType.Product)
            .map(lineItem => {
                const product = curr.lineItemProducts.find(product => product.id === lineItem.entityId) as Product;
                const version = curr.lineItemProductVersions.find(version => version.productId === product.id) as ProductVersion;
                return {
                    lineItem,
                    product,
                    version,
                }
            }),
        materialLineItems: curr.lineItems
            .filter(li => li.type === BillOfMaterialsLineItemType.Material)
            .map(lineItem => ({
                lineItem,
                material: curr.lineItemMaterials.find(material => material.id === lineItem.entityId) as PlasticsMaterial
            })),
    }
}
